async function pipe(
  data: Uint8Array,
  transform: CompressionStream | DecompressionStream,
): Promise<Uint8Array> {
  const stream = new ReadableStream<BufferSource>({
    start(controller) {
      controller.enqueue(data as Uint8Array<ArrayBuffer>);
      controller.close();
    },
  }).pipeThrough<Uint8Array>(transform);
  return new Uint8Array(await new Response(stream).arrayBuffer());
}

// Hermes (React Native) ships none of CompressionStream / ReadableStream /
// Response, so packs would be undecodable on mobile via the native path.
// Detect once and fall back to fflate's pure-JS implementation there; web and
// node keep the zero-dependency native streams.
const hasNativeStreams =
  typeof CompressionStream !== 'undefined' &&
  typeof ReadableStream !== 'undefined' &&
  typeof Response !== 'undefined';

// Hermes is the only runtime that reaches the fallback.
// dynamic-import -- defer fflate so web and Node never load it.
const loadFflate = () => import('fflate');

export const deflateRaw = async (data: Uint8Array): Promise<Uint8Array> => {
  if (hasNativeStreams) return pipe(data, new CompressionStream('deflate-raw'));
  const { deflateSync } = await loadFflate();
  return deflateSync(data);
};

export const inflateRaw = async (data: Uint8Array): Promise<Uint8Array> => {
  if (hasNativeStreams)
    return pipe(data, new DecompressionStream('deflate-raw'));
  const { inflateSync } = await loadFflate();
  return inflateSync(data);
};
